import { createContext, useContext, useState, useCallback, useEffect } from "react";

const CallContext = createContext(null);
const STORAGE_KEY = "tc_active_call";

export function CallProvider({ children }) {
  const [activeCall, setActiveCall] = useState(() => {
    try {
      const saved = sessionStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });
  const [isMinimized, setIsMinimized] = useState(() => !!sessionStorage.getItem(STORAGE_KEY));

  // Sync to sessionStorage whenever activeCall changes
  useEffect(() => {
    if (activeCall) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(activeCall));
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }, [activeCall]);

  const joinCall = useCallback((roomName, dailyUrl, meetingToken, inviteeNames) => {
    setActiveCall({ roomName, dailyUrl, meetingToken, inviteeNames: inviteeNames || [] });
    setIsMinimized(false);
  }, []);

  const leaveCall = useCallback(() => {
    setActiveCall(null);
    setIsMinimized(false);
  }, []);

  const minimize = useCallback(() => setIsMinimized(true), []);
  const maximize = useCallback(() => setIsMinimized(false), []);

  return (
    <CallContext.Provider value={{ activeCall, isMinimized, joinCall, leaveCall, minimize, maximize }}>
      {children}
    </CallContext.Provider>
  );
}

export function useCall() {
  return useContext(CallContext);
}
